// src/components/DynamicHead.js
import { useEffect, useState } from "react";
import { getStorage, ref as sref, getDownloadURL } from "firebase/storage";

/**
 * Updates <title>, favicon, and theme-color based on school doc.
 */
export default function DynamicHead({ school }) {
  const [resolvedLogo, setResolvedLogo] = useState(null);

  useEffect(() => {
    if (!school) return;

    // ----- Title -----
    document.title = `${school.name || "School"} | LearnSmart`;

    // ----- Resolve favicon -----
    let cancelled = false;
    const resolve = async () => {
      if (school.logoUrl && /^https?:\/\//i.test(school.logoUrl)) {
        if (!cancelled) setResolvedLogo(school.logoUrl);
        return;
      }
      const fp =
        school.logoFile?.fullPath ||
        school.logoFile?.path ||
        school.logoFile?.name;
      if (fp) {
        try {
          const url = await getDownloadURL(sref(getStorage(), fp));
          if (!cancelled) setResolvedLogo(url);
          return;
        } catch {}
      }
      if (!cancelled) setResolvedLogo("/logo.png"); // fallback
    };
    resolve();
    return () => {
      cancelled = true;
    };
  }, [school]);

  useEffect(() => {
    if (!resolvedLogo) return;

    const setIcon = (rel, sizes) => {
      let link = document.querySelector(
        `link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ""}`
      );
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        if (sizes) link.sizes = sizes;
        document.head.appendChild(link);
      }
      link.href = resolvedLogo;
    };

    setIcon("icon", "32x32");
    setIcon("apple-touch-icon");

    const themeMeta =
      document.querySelector('meta[name="theme-color"]') ||
      (() => {
        const m = document.createElement("meta");
        m.name = "theme-color";
        document.head.appendChild(m);
        return m;
      })();
    themeMeta.setAttribute("content", "#4f46e5");
  }, [resolvedLogo]);

  return null;
}
